<template>
    <div>
        <m-title title="Szczegóły subskrypcji" />
        <div class="l-row">
            <div class="l-row__column">
                <p class="a-label">Nazwa pakietu</p>
                <p class="a-text">
                    {{ activeSubscription.name }}
                </p>

                <p class="a-label">Okres subskrypcji</p>
                <p class="a-text">
                    {{
                        activeSubscription.activeFrom &&
                            $dayjs(activeSubscription.activeFrom).format(
                                'DD.MM.YYYY'
                            )
                    }}
                    -
                    {{
                        activeSubscription.activeTo &&
                            $dayjs(activeSubscription.activeTo).format(
                                'DD.MM.YYYY'
                            )
                    }}
                </p>

                <p class="a-label">Zapłacona wartość</p>
                <p v-if="activeSubscription.price === 'Darmowy'" class="a-text">
                    Darmowy pakiet
                </p>
                <p v-else class="a-text">
                    {{ activeSubscription.price }} zł ({{ pricePerMonth }}
                    zł/mc)
                </p>
            </div>
        </div>
        <div class="l-row">
            <div class="l-row__column">
                <button class="a-button a-button--fullwidth" @click="$router.push({ name: 'settings' })">Wróć</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SubscriptionDetails',
    computed: {
        activeSubscription() {
            return this.$store.getters['subscriptions/activeSubscription']
        },
        pricePerMonth() {
            const monthDifference = () => {
                const date1 = this.$dayjs(this.activeSubscription.activeTo)
                const date2 = this.$dayjs(this.activeSubscription.activeFrom)
                const res = date1.diff(date2, 'month')
                return res
            }
            const sum = this.activeSubscription.price / monthDifference()
            return sum.toFixed(2)
        }
    }
}
</script>
